/**
 * Testi italiani dell'area di amministrazione (ADR 0030 §3, tappa 7): schede
 * e pagina Utenti in stile AdminPulse (conteggi, ricerca, filtri, azzeramento
 * della verifica in due passaggi).
 */

/** Testi dell'amministrazione. */
export const admin = {
  /** Nome accessibile della navigazione fra le schede. */
  tabsLabel: 'Sezioni dell’amministrazione',
  /** Schede. */
  tabs: {
    /** Utenti. */
    users: 'Utenti',
    /** Progetti. */
    projects: 'Progetti',
    /** Piattaforma. */
    platform: 'Piattaforma',
    /** Monitoraggio. */
    monitoring: 'Monitoraggio',
  },

  /** Pagina Utenti. */
  users: {
    /** Nome accessibile della fila dei conteggi. */
    countsLabel: 'Conteggi degli utenti',
    /** Utenti. */
    total: 'Utenti',
    /** Amministratori. */
    admins: 'Amministratori',
    /** Utenti per piano. */
    perPlan: 'Piano {{plan}}',
    /** Ricerca. */
    search: 'Cerca utenti',
    /** Segnaposto della ricerca. */
    searchPlaceholder: 'Nome utente, nome o email',
    /** Filtro del piano. */
    planFilter: 'Piano',
    /** Tutti i piani. */
    allPlans: 'Tutti i piani',
    /** Filtro del ruolo. */
    roleFilter: 'Ruolo',
    /** Tutti i ruoli. */
    allRoles: 'Tutti i ruoli',
    /** Senza ruoli. */
    noRole: 'Senza ruoli',
    /** Togli i filtri. */
    clear: 'Togli i filtri',
    /** Utenti mostrati. */
    shown: '{{shown}} di {{total}}',
    /** Nessun utente con i filtri. */
    noMatch: 'Nessun utente con questi filtri.',
    /** Colonna dei set. */
    sets: 'Set',
    /** Colonna dei token. */
    tokens: 'Token del mese',
    /** Consumo non disponibile. */
    usageUnavailable: 'Set e token del mese non disponibili.',
  },

  /** Azzeramento della verifica in due passaggi. */
  mfa: {
    /** Pulsante della riga. */
    reset: 'Azzera verifica',
    /** Nome accessibile del pulsante. */
    resetNamed: 'Azzera la verifica in due passaggi di {{name}}',
    /** Domanda della conferma. */
    question: 'Azzerare la verifica in due passaggi di {{name}}?',
    /** Conseguenza. */
    consequence: 'Al prossimo accesso {{name}} deve registrarla di nuovo con l’app di autenticazione. I codici di recupero di prima non valgono più e le sue sessioni aperte si chiudono.',
    /** Esito. */
    done: 'Verifica in due passaggi di {{name}} azzerata.',
    /** Utente senza registrazione. */
    notEnrolled: '{{name}} non ha registrato la verifica in due passaggi.',
    /** Errore. */
    failed: 'Azzeramento non riuscito. Riprova.',
  },
};

/** Forma dei testi dell'amministrazione, usata per tipare le altre lingue. */
export type Admin = typeof admin;
